const _ = require('lodash')

function getBaseApiURL(version = '') {
  return process.env.NODE_ENV === 'production'
    ? `api/${version}`
    : `${version}/`
}

module.exports = {
  getBaseApiURL: getBaseApiURL
}